module.exports = __webpack_public_path__ + "static/va-d76a4c0a9d11e9d29aae93d9972e913a.svg";